import styled from 'styled-components';
import { colors, IoApps } from '../../../../variables';

export const AppIcon = styled(IoApps)`
  color: ${colors.white};
`;
